const React = require('react');
const map = require('mn-utils/map');
const upperFirst = require('mn-utils/upperFirst');
const Tooltip = require('../../../../dumb/Tooltip/B');

const DataBlock = require('./DataBlock');
const {DisplayIdMerchant, DisplayDataMerchant} = require("../../../../dumb/DisplayData");
const {DisplayStatusTrx} = require("../../../../dumb/StatusDisplay");

module.exports = (props) => {
  const data = props.data || {};

  const status = data.lifeflow;

  const dataArr = [
    {
      title: 'Customer',
      value: (
        <DisplayDataMerchant className="fhaS">
          {data.customer_email}
        </DisplayDataMerchant>
      ),
    },
    {
      title: 'External Customer ID',
      value: (
        <DisplayIdMerchant className="fhaS">
          {data.customer_external_id}
        </DisplayIdMerchant>
      ),
    },
    {
      title: 'External TRX ID',
      value: (
        <DisplayDataMerchant className="fhaS">
          {data.merchant_trx_id}
        </DisplayDataMerchant>
      ),
    },
    {
      title: 'Status',
      value: (
        <DisplayStatusTrx status={status} />
      ),
    },
  ];

  return (
    <div className="layoutRow fxwWrap mh-25 mt10">
      {map(dataArr, (item, i) => (
        <div key={i} className="w1/4 w1/2@m w@m2 mt25 ph25">
          <DataBlock title={item.title} value={item.value} />
        </div>
      ))}
    </div>
  );
};
